/* eslint-disable no-mixed-operators */
import { distanceInWordsToNow, differenceInHours } from "date-fns";
//Liitless imports
import { getDateForTimeZone, formatToTimeZone } from "@limitless/common/utils";
export const formatPercentage = (rawValue, wholeNumber = false, noValueRepresentation = "0%") => {
  const value = String(rawValue);
  if (!value || value === "" || value === "null" || value === "0") {
    return noValueRepresentation;
  }
  if (wholeNumber && value.includes(".")) {
    return `${`${value}`.split(".")[0]}%`;
  }
  return `${value}%`;
};
export const formatResponseTime = valueInSeconds => {
  if (!valueInSeconds) {
    return "-";
  }
  try {
    const secNum = parseInt(valueInSeconds, 10);
    let hours = Math.floor(secNum / 3600);
    let minutes = Math.floor((secNum - hours * 3600) / 60);
    let seconds = secNum - hours * 3600 - minutes * 60;
    if (hours < 10) {
      hours = `0${hours}`;
    }
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }
    return `${hours}:${minutes}:${seconds}`;
  } catch (error) {
    return "--";
  }
};
export const formatReportDate = (dateString, options = {}, timeZone) => {
  const {
    includeMilliSeconds = false,
    includeSeconds = false,
    showDateOnly = false,
    customFormat,
    showDevDateTime = false
  } = options;
  if (!dateString && dateString !== 0) {
    return "";
  }
  let dateFormat = "DD/MM/YYYY HH:mm";
  if (customFormat) {
    dateFormat = customFormat;
  } else {
    if (typeof includeSeconds === "boolean" && includeSeconds) {
      dateFormat = "DD/MM/YYYY HH:mm:ss";
    }
    if (typeof includeMilliSeconds === "boolean" && includeMilliSeconds) {
      dateFormat = "DD/MM/YYYY HH:mm:ss:SSS";
    }
    if (typeof showDateOnly === "boolean" && showDateOnly) {
      dateFormat = "DD/MM/YYYY";
    }
  }
  const date = new Date(dateString);
  return formatToTimeZone(date, showDevDateTime ? "DD/MM/YYYY HH:mm:ss:SSS" : dateFormat, timeZone);
};
export const formatReportDateDistanceInWords = (dateString, timeZone) => {
  //TODO this doesn't actually repect user's timezone, nor has it ever :)
  const date = getDateForTimeZone(dateString, timeZone);
  const today = getDateForTimeZone(new Date(), timeZone);
  const formattedDate = distanceInWordsToNow(dateString, {
    includeSeconds: true,
    addSuffix: true
  });
  const numberOfHours = differenceInHours(date, today);
  return {
    formattedDate,
    numberOfHours
  };
};